import { action, computed, makeObservable, observable } from 'mobx'

import { DTO } from '../DTO'
import type { PaymentStudentColl } from './PaymentStudentColl'

export class StudentPayment extends DTO {
  private _studentPaymentColl: PaymentStudentColl

  get studentPaymentList() {
    return [...this._studentPaymentColl.toArr]
  }

  constructor(studentPaymentColl: PaymentStudentColl) {
    super()
    makeObservable<this, '_studentPaymentColl'>(this, {
      _studentPaymentColl: observable,
      studentPaymentList: computed,
      addStudentPayment: action,
    })
    this._studentPaymentColl = studentPaymentColl
  }

  addStudentPayment(extraStudentPaymentColl: PaymentStudentColl) {
    this._studentPaymentColl?.adds(extraStudentPaymentColl)
  }
}
